module.exports = __webpack_public_path__ + "e242b80171bf8c0af569f5d8e10debf9.pdf";